import safeJSONParse from '../utils/safeJSONParse'

//attach a JSON blob of section.blocks for the carousel text to be shown alongside the image. Update it on click or swipe.
const carouselText = () => {
  if (!document.querySelector('[data-carousel-data]')) {return}
  const carouselEl = document.querySelector('[data-carousel-data]')
  const carouselData = safeJSONParse(carouselEl.dataset.carouselData)
  const index = window.blubolt.glides['carousel']._i

  if (!document.querySelector('[data-carousel-title]')) {return}
  const title = document.querySelector('[data-carousel-title]')
  const subTitle = document.querySelector('[data-carousel-sub-title]')
  const text = document.querySelector('[data-carousel-text]')

  if (!title || !subTitle || !text || !carouselData) {return}
  title.innerHTML = carouselData[index].title
  subTitle.innerHTML = carouselData[index].subTitle
  text.innerHTML = carouselData[index].text
}

//set counter for carousel e.g. 2/10
const setCount = () => {
  const track = document.querySelector('[data-glide-el-about]')
  const counter = document.querySelector('[data-carousel-counter]')
  const numberOfImages = track.children[0].children.length
  if (numberOfImages <= 0 || !track) {return}
  const id = document.querySelector('[data-glide-location]').dataset.glideId
  counter.innerHTML = `${window.blubolt.glides[id]._i + 1} / ${numberOfImages}`
}

const carouselInit = () => {
  if (!document.querySelector('[data-carousel-counter]') || !document.querySelector('[data-glide-id]')) {return}
  const buttons = document.querySelectorAll('[data-glide-dir]')
  carouselText()
  setCount()
  

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      setCount()
      carouselText()
    })
  }) 
}

export { carouselInit, carouselText, setCount }